export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/kubota.b3d9cb03.svg","height":250,"width":250,"blurWidth":0,"blurHeight":0};